import kycFlowSaga from './kycSaga';
import onboardingFlowSaga from './onboardingSaga';

const moSagas = [kycFlowSaga(), onboardingFlowSaga()];
export default moSagas;
